import { Inject, Injectable, InjectionToken } from "@angular/core";
import type { organisationEditObjectivePageRoute, teamEditObjectivePageRoute } from "./edit-objective-page/edit-objective-page.route";
import { ObjectiveViewType } from "./objective-view-type.enum";
import type { organisationObjectivesPageRoute, teamObjectivesPageRoute } from "./objectives-page/objectives-page.route";

// Needed to avoid circular dependencies that are breaking tests.
interface IObjectiveRoutes {
    teamEditObjectivePageRoute: typeof teamEditObjectivePageRoute;
    organisationEditObjectivePageRoute: typeof organisationEditObjectivePageRoute;
    teamObjectivesPageRoute: typeof teamObjectivesPageRoute;
    organisationObjectivesPageRoute: typeof organisationObjectivesPageRoute;
}

export const OBJECTIVE_ROUTES = new InjectionToken<IObjectiveRoutes>("OBJECTIVE_ROUTES");

@Injectable({
    providedIn: "root",
})
export class ObjectivesRouteService {
    public constructor(@Inject(OBJECTIVE_ROUTES) private routes: IObjectiveRoutes) {}

    public getEditObjectivePageRoute(objectiveId: number, teamId?: number) {
        if (teamId) {
            return this.routes.teamEditObjectivePageRoute.getRoute({ objectiveId, teamId });
        } else {
            return this.routes.organisationEditObjectivePageRoute.getRoute({ objectiveId });
        }
    }

    public getObjectivePageRoute(teamId?: number, view?: ObjectiveViewType) {
        const searchParams = view
            ? { view }
            : {};

        if (teamId) {
            return this.routes.teamObjectivesPageRoute.getRouteObject({ teamId }, searchParams);
        } else {
            return this.routes.organisationObjectivesPageRoute.getRouteObject(undefined, searchParams);
        }
    }

    public gotoObjectivePageRoute(teamId?: number, view?: ObjectiveViewType) {
        const searchParams = view
            ? { view }
            : {};

        if (teamId) {
            return this.routes.teamObjectivesPageRoute.gotoRoute({ teamId }, searchParams);
        } else {
            return this.routes.organisationObjectivesPageRoute.gotoRoute(undefined, searchParams);
        }
    }

    public navigateToObjectivePageRoute(teamId?: number) {
        this.gotoObjectivePageRoute(teamId).subscribe();
    }

    public gotoEditObjectivePageRoute(objectiveId: number, teamId?: number) {
        if (teamId) {
            return this.routes.teamEditObjectivePageRoute.gotoRoute({ objectiveId, teamId });
        } else {
            return this.routes.organisationEditObjectivePageRoute.gotoRoute({ objectiveId });
        }
    }
}
